import { addLocale, useLocale } from 'ttag';

type AppLocale = 'uk' | 'en';

/**
 * Need be run before mount Application
 * For runtime change need trigger
 */
export const setLocale = async (locale: AppLocale = 'uk'): Promise<boolean> => {
  switch (locale) {
    case 'en': {
      const { default: en } = await import('./en.po');
      addLocale('en', en);
      useLocale('en');
      return true;
    }
    case 'uk':
    default:
      return false;
  }
};
